import React, { Component } from 'react';
import {
  Paper, Table, TableHead, TableBody, TableRow, TableCell, Typography, TextField, Radio, IconButton, Menu, MenuItem, Button,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { MoreVert } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { resourceFields, variationFields } from '../../data/Constants';
import { resourceFormStyle, variationComponentStyles, variationStylesForWithStylesHOC } from '../../css/style';
import DeleteConfirmDialog from './DeleteConfirmDialog';
import { isItemInvalid } from '../../utils/Functions';

const styles = resourceFormStyle();
const variationStyles = variationComponentStyles();

class Variation extends Component {
  constructor(props) {
    super(props);
    const {
      id, name, attribute_name, attribute_value, price, isDefault,
    } = props.product.productItems[0];
    this.state = {
      productItems: [
        {
          id,
          name,
          attribute_name,
          attribute_value,
          price,
          isDefault,
        },
      ],
      variationCounter: 0,
      isMenuOpen: false,
      isDeleteConfirmDialogOpen: false,
      dataInDeleteConfirmDialog: '',
      variation0IsFieldInvalid: new Array(variationFields.length),
      variation0InvalidFieldMessage: new Array(variationFields.length),
    };
  }

  componentDidMount = () => {
    const { productItems } = this.props.product;
    productItems.forEach((item) => {
      if (item.selectedItem) {
        item.selectedItem = false;
      }
    });
    const variationCounter = productItems[productItems.length - 1].id;
    this.setState({
      productItems,
      variationCounter,
    });
  }

  componentDidUpdate = (prevProps) => {
    if (!isEqual(prevProps, this.props) && this.props.product.productItems) {
      const { productItems } = this.props.product;
      this.setState({ productItems });
    }
  }

  renderTableHeader = fields => (
    <TableRow key='header' style={styles.tableHead}>
      {fields.map(field => (
        <TableCell variant='head' key={field.key} style={styles.tableCell}>
          {field.title}
        </TableCell>
      ))}
      <TableCell variant='head' key='iconButton' style={styles.tableCell} />
    </TableRow>
  )

  //
  renderErrorMessage = (itemId, fieldKey) => {
    const areItemFieldsInvalid = this.state[`variation${itemId}IsFieldInvalid`] || null;
    if (!areItemFieldsInvalid) return;
    const isThisFieldInvalid = areItemFieldsInvalid[fieldKey];
    if (!isThisFieldInvalid) return;

    const invalidFieldMessages = this.state[`variation${itemId}InvalidFieldMessage`] || null;
    if (!invalidFieldMessages) return;
    return (
      <Typography style={variationStyles.errorMessage}>
        {invalidFieldMessages[fieldKey]}
      </Typography>
    );
  }

  getTextFieldStyle = (itemId, fieldKey) => {
    const normalStyle = fieldKey !== 'price' ? variationStyles.textFieldStyle : variationStyles.priceFieldStyle;
    const areItemFieldsInvalid = this.state[`variation${itemId}IsFieldInvalid`] || null;
    if (!areItemFieldsInvalid) return normalStyle;
    const isThisFieldInvalid = areItemFieldsInvalid[fieldKey];
    if (!isThisFieldInvalid) return normalStyle;
    const errorStyle = fieldKey !== 'price' ? variationStyles.errorTextField : variationStyles.errorPriceField;
    return errorStyle;
  }

  getCellRootClassStyle = (fieldKey, classes) => {
    if (!classes || !classes.root) return null;
    if (fieldKey === 'isDefault') return { root: classes.default };
    return { root: classes.root };
  }

  renderTableRow = (productItem, fields) => {
    const { classes } = this.props;
    return (
      <TableRow key={productItem.id} style={{ height: '50px' }}>
        {fields.map(field => (
          <TableCell key={field.key} classes={this.getCellRootClassStyle(field.key, classes)}>
            {field.key !== 'isDefault'
              ? (
                <React.Fragment>
                  <TextField
                    key={field.key}
                    value={productItem[field.key]}
                    style={this.getTextFieldStyle(productItem.id, field.key)}
                    margin='normal'
                    InputProps={{ disableUnderline: true }}
                    onChange={event => this.onChangeVariation(event, field, productItem.id)}
                  />
                  {this.renderErrorMessage(productItem.id, field.key)}
                </React.Fragment>
              )
              : (
                <React.Fragment>
                  <Radio
                    checked={productItem.isDefault}
                    onChange={() => this.onClickIsDefaultRadio(productItem)}
                    required
                    style={variationStyles.radioStyle}
                  />
                  {this.renderErrorMessage(productItem.id, field.key)}
                </React.Fragment>
              )
            }
          </TableCell>
        ))}
        <TableCell key='viewMore' style={styles.tableCell}>
          <IconButton
            style={styles.iconButton}
            onClick={event => this.handleMenuOpen(event, productItem.id)}
          >
            <MoreVert />
          </IconButton>
          <Menu
            key={productItem.id}
            open={Boolean(productItem.anchorEl)}
            anchorEl={productItem.anchorEl}
            onClose={event => this.handleMenuClose(event, productItem.id)}
          >
            <MenuItem
              onClick={() => this.onClickDelete(productItem.id)}
              disabled={Array.isArray(this.props.product.productItems) && this.props.product.productItems.length < 2}
            >
              Delete
            </MenuItem>
            {<MenuItem onClick={() => this.onClickAdvancedVariationOptions(productItem.id)}>Advanced Options</MenuItem>}
            {<MenuItem onClick={() => this.onClickDuplicate(productItem.id)}>Duplicate</MenuItem>}
          </Menu>
        </TableCell>
      </TableRow>
    );
  }

  onChangeVariation = (event, field, itemId) => {
    const { onChangeInput } = this.props;
    const { productItems } = this.state;
    let currentIndex = productItems.findIndex(item => item.id === itemId);
    productItems[currentIndex][field.key] = event.target.value;

    const allVariationsInvalidState = {};
    productItems.forEach((item) => {
      const { isFieldInvalid, invalidFieldMessage } = isItemInvalid(item);
      allVariationsInvalidState[`variation${item.id}IsFieldInvalid`] = isFieldInvalid;
      allVariationsInvalidState[`variation${item.id}InvalidFieldMessage`] = invalidFieldMessage;
    });
    this.setState(allVariationsInvalidState);
    onChangeInput(event, field, undefined, undefined, currentIndex);
  }

  onClickIsDefaultRadio = (productItem) => {
    const { productItems } = this.state;
    let stateCopy = this.state;
    productItems.forEach((item, i) => {
      if (item.id === productItem.id) {
        stateCopy.productItems[i].isDefault = true;
      } else {
        stateCopy.productItems[i].isDefault = false;
      }
    });
    this.setState(stateCopy);
  }

  handleMenuOpen = (event, id) => {
    const { productItems } = this.state;
    const items = productItems.map((item) => {
      if (item.id === id) {
        item.anchorEl = event.currentTarget;
      }
      return item;
    });
    this.setState({
      isMenuOpen: true,
      productItems: items,
    });
  }

  handleMenuClose = (event, id) => {
    const productItems = this.state.productItems.slice();
    let currentIndex = productItems.findIndex(item => item.id === id);
    productItems[currentIndex].anchorEl = null;
    this.setState({
      productItems,
      isMenuOpen: false,
    });
  }

  onClickDelete = (id) => {
    this.handleMenuClose(null, id);
    const itemForDeletion = this.state.productItems && this.state.productItems.find(item => item.id === id);
    this.setState({
      isDeleteConfirmDialogOpen: true,
      idForDeletion: id,
      itemForDeletion,
    });
  }

  onClickAdvancedVariationOptions = (itemId) => {
    const {
      history, product, categories,
    } = this.props;


    let items = product.productItems && product.productItems.filter(item => item.id !== itemId);
    items.forEach((item) => {
      if (item.selectedItem) {
        item.selectedItem = false;
      }
    });

    let selectedItem = product.productItems && product.productItems.find(item => item.id === itemId);
    selectedItem.selectedItem = true;
    const { anchorEl, ...item } = selectedItem;

    let selectedIndex = product.productItems.findIndex(item => item.id === itemId);

    items.splice(selectedIndex, 0, item);

    history.push({
      pathname: '/products/items/create',
      state: {
        product: {
          ...this.props.product,
          productItems: items,
        },
        categories,
      },
    });
  }

  onClickDuplicate = (itemId) => {
    this.handleMenuClose(null, itemId);
    const { onClickDuplicateVariation } = this.props;
    let productItemsCopy = this.state.productItems.slice();
    const itemForDuplication = productItemsCopy.find(item => item.id === itemId);
    const {
      id,
      isDefault,
      integrationPLU,
      ...duplicatedItem
    } = itemForDuplication;

    const variationCounter = this.state.variationCounter + 1;
    if (duplicatedItem['out-of-stock']) {
      delete duplicatedItem['out-of-stock'];
    }
    duplicatedItem.id = variationCounter;
    duplicatedItem.isDefault = false;
    productItemsCopy.push(duplicatedItem);
    this.setState({ variationCounter });
    onClickDuplicateVariation(productItemsCopy);
  }

  onCloseDeleteConfirmDialog = () => {
    this.setState({
      isDeleteConfirmDialogOpen: false,
    });
  }

  onClickConfirmDeleteButton = async () => {
    const { product, onClickConfirmDeleteVariation } = this.props;
    const { idForDeletion, productItems } = this.state;
    onClickConfirmDeleteVariation(product.name, idForDeletion, productItems);
    this.onCloseDeleteConfirmDialog();
  }

  onClickAddVariation = (index) => {
    const { onClickAddNewVariation } = this.props;
    let productItemsCopy = this.state.productItems.slice();
    let variationCounter = this.state.variationCounter + 1;
    productItemsCopy.push({
      attribute_name: this.state.productItems[0].attribute_name,
      attribute_value: null,
      price: null,
      isDefault: false,
      id: variationCounter,
    });
    this.setState({
      variationCounter,
    });
    onClickAddNewVariation(productItemsCopy);
  }

  render() {
    const { product } = this.props;
    const { productItems } = product;
    const fields = resourceFields.items.filter(field => variationFields.includes(field.key));
    return (
      <React.Fragment>
        <div style={styles.subResourceContainer}>
          <div style={styles.subResourceContainerHeader}>
            <Typography style={styles.title}>
              Variations
            </Typography>
            <Button
              onClick={() => this.onClickAddVariation(productItems.length)}
              style={variationStyles.addVariationButton}
            >
              ADD NEW VARIATION
            </Button>
          </div>
        </div>
        <Paper style={variationStyles.paper}>
          <div>
            <Table>
              <TableHead style={styles.tableRowContainer}>
                {this.renderTableHeader(fields)}
              </TableHead>
              <TableBody style={styles.tableRowContainer}>
                {productItems && productItems.map((productItem, index) => (this.renderTableRow(productItem, fields, index)))}
              </TableBody>
            </Table>
          </div>
        </Paper>
        {
          this.state.isDeleteConfirmDialogOpen
          && (
            <DeleteConfirmDialog
              resourceName='items'
              isDialogOpen={this.state.isDeleteConfirmDialogOpen}
              deleteDataName={this.state.itemForDeletion && this.state.itemForDeletion.name}
              onCloseDialog={() => this.onCloseDeleteConfirmDialog()}
              onClickConfirmButton={() => this.onClickConfirmDeleteButton()}
            />
          )
        }
      </React.Fragment>
    );
  }
}

Variation.propTypes = {
  onChangeInput: PropTypes.func.isRequired,
  onClickConfirmDeleteVariation: PropTypes.func.isRequired,
  onClickAddNewVariation: PropTypes.func.isRequired,
  product: PropTypes.objectOf(PropTypes.any).isRequired,
  categories: PropTypes.array.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withStyles(variationStylesForWithStylesHOC)(Variation);
